import React, { Component } from 'react'

export default class Comparison extends Component {
  render() {
    const traditionalItems = [
      'Complex Reservations with Paper & Pen',
      'Manual Pricing, Fixed Rates',
      'Manual Inventory Control',
      'Limited Online Reach',
      'Paper-Based Inefficiencies',
      'Location-Restricted Access',
      'Limited Offline Audience',
      'Aspiration to Increase Bookings',
      'Manual Processes and Effort',
      'Limited Means to Enhance Experience',
      'Restricted Customer Reach'
    ];

    const tourzoneItems = [
      'Real-Time Booking for More Sales',
      'Smart Pricing for Increased Sales',
      'Automated Inventory Management',
      'Wider Distribution for More Sales',
      'Paperless Efficiency for Sales',
      'Anytime, Anywhere Access for Sales',
      'Broaden Audience with Online Bookings',
      'Boost Bookings and Sales Opportunities',
      'Streamlined Automation for Efficiency',
      'Enhanced Guest Experience and Satisfaction',
      'Expanded Reach to More Customers'
    ];

    return (
      <div style={{
        padding: '60px 5%',
        backgroundColor: '#fafbfc'
      }}>
        {/* Section Header */}
        <div style={{ 
          textAlign: 'center', 
          marginBottom: '40px'
        }}>
          <div style={{
            display: 'inline-block',
            backgroundColor: 'rgba(255, 107, 107, 0.1)',
            color: '#ff6b6b',
            fontSize: '10px',
            fontWeight: '700',
            letterSpacing: '2px',
            padding: '6px 16px',
            borderRadius: '20px',
            marginBottom: '15px',
            textTransform: 'uppercase'
          }}>
            Modernizing Sales Dynamics
          </div>
          <h2 style={{
            fontSize: '32px',
            fontWeight: '700',
            margin: '0',
            color: '#1a2332',
            lineHeight: '1.3'
          }}>
            Traditional Suppliers
            <span style={{ 
              color: '#5c636c',
              fontSize: '24px',
              fontWeight: '400',
              display: 'inline-block',
              margin: '0 8px'
            }}>vs.</span>
            <span style={{
              background: 'linear-gradient(135deg, #4db8cd 0%, #3da5ba 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent'
            }}>
Holideus Visionaries
            </span>
          </h2>
        </div>

        {/* Comparison Container */}
        <div style={{
          maxWidth: '1000px',
          margin: '0 auto'
        }}>
          <div className='row g-0' style={{
            backgroundColor: '#fff',
            borderRadius: '16px',
            overflow: 'hidden',
            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.06)'
          }}>
            {/* Traditional Suppliers Column */}
            <div className='col-md-6' style={{
              padding: '0',
              borderRight: '1px solid #f0f4f7'
            }}>
              {/* Header */}
              <div style={{
                padding: '25px 30px',
                background: 'linear-gradient(135deg, #f8f9fa 0%, #fff 100%)',
                borderBottom: '1px solid #f0f4f7'
              }}>
                <h3 style={{
                  fontSize: '15px',
                  fontWeight: '700',
                  color: '#2c3e50',
                  margin: '0',
                  letterSpacing: '0.5px',
                  textTransform: 'uppercase'
                }}>
                  Traditional Suppliers
                </h3>
              </div>

              {/* Content */}
              <div style={{ padding: '25px 30px' }}>
                {traditionalItems.map((item, index) => (
                  <div key={index} style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    marginBottom: '14px',
                    paddingBottom: '14px',
                    borderBottom: index !== traditionalItems.length - 1 ? '1px solid #f5f7fa' : 'none'
                  }}>
                    <div style={{
                      minWidth: '18px',
                      height: '18px',
                      marginRight: '12px',
                      marginTop: '2px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: 'rgba(255, 107, 107, 0.1)',
                      borderRadius: '4px'
                    }}>
                      <i className="bi bi-x" style={{
                        fontSize: '14px',
                        color: '#ff6b6b',
                        fontWeight: 'bold'
                      }}></i>
                    </div>
                    <span style={{
                      fontSize: '13px',
                      color: '#5c636c',
                      lineHeight: '1.5',
                      fontWeight: '400'
                    }}>
                      {item}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            {/* Tourzone Suppliers Column */}
            <div className='col-md-6' style={{ padding: '0' }}>
              {/* Header */}
              <div style={{
                padding: '25px 30px',
                background: 'linear-gradient(135deg, rgba(77, 184, 205, 0.08) 0%, rgba(77, 184, 205, 0.03) 100%)',
                borderBottom: '1px solid rgba(77, 184, 205, 0.15)'
              }}>
                <h3 style={{
                  fontSize: '15px',
                  fontWeight: '700',
                  color: '#2c3e50',
                  margin: '0',
                  letterSpacing: '0.5px',
                  textTransform: 'uppercase'
                }}>
Holideus Suppliers
                </h3>
              </div>

              {/* Content */}
              <div style={{ padding: '25px 30px' }}>
                {tourzoneItems.map((item, index) => (
                  <div key={index} style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    marginBottom: '14px',
                    paddingBottom: '14px',
                    borderBottom: index !== tourzoneItems.length - 1 ? '1px solid #f5f7fa' : 'none'
                  }}>
                    <div style={{
                      minWidth: '18px',
                      height: '18px',
                      marginRight: '12px',
                      marginTop: '2px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      background: 'linear-gradient(135deg, rgba(77, 184, 205, 0.15) 0%, rgba(77, 184, 205, 0.08) 100%)',
                      borderRadius: '4px'
                    }}>
                      <i className="bi bi-check2" style={{
                        fontSize: '12px',
                        color: '#4db8cd',
                        fontWeight: 'bold'
                      }}></i>
                    </div>
                    <span style={{
                      fontSize: '13px',
                      color: '#2c3e50',
                      lineHeight: '1.5',
                      fontWeight: '500'
                    }}>
                      {item}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div style={{ 
          textAlign: 'center', 
          marginTop: '40px'
        }}>
          <button style={{
            background: 'linear-gradient(135deg, #4db8cd 0%, #3da5ba 100%)',
            color: 'white',
            border: 'none',
            padding: '12px 32px',
            borderRadius: '8px',
            fontSize: '14px',
            fontWeight: '600',
            cursor: 'pointer',
            boxShadow: '0 6px 16px rgba(77, 184, 205, 0.25)',
            transition: 'all 0.3s ease'
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 8px 20px rgba(77, 184, 205, 0.35)';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 6px 16px rgba(77, 184, 205, 0.25)';
          }}
          >
            Start Your Digital Journey
          </button>
        </div>
      </div>
    )
  }
}